import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _defineProperty from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import FooterToolBar from '../../../components/tool/FooterToolBar.vue';
import { getLanguageList as _getLanguageList } from '@/services/common';
import { updateOtherSetting } from '@/services/systemsetting';
import fanyiPic from '@/assets/fanyi.png';
export default {
  name: 'other',
  components: {
    FooterToolBar: FooterToolBar
  },
  i18n: require('./../i18n-basucSettings'),
  props: ['systemSetting'],
  watch: {
    systemSetting: function systemSetting() {
      var self = this;
      self.systemSettingData = self.systemSetting;
      this.getLanguageList();
    }
  },
  data: function data() {
    return _defineProperty({
      fanyiPic: fanyiPic,
      saveLoading: false,
      clientLanguageDisplayList: [],
      //客户端显示语言CheckBox选项
      rules: {
        clientLanguageDisplayIds: [{
          required: true,
          message: this.$t('public.pleaseSelect'),
          trigger: 'change'
        }]
      },
      systemSettingData: this.systemSetting,
      defaultLangObj: "",
      languageList: [],
      dataForm: {
        stockThreshold: '',
        arrivalNoticeThreshold: '',
        lowStockLimit: '',
        maxLoginNumber: '',
        clientLanguageDisplayIds: [],
        /* 客户端语言显示 */
        shopDefaultLanguage: "",
        sendBundleStatus: 0,
        /* 同捆发货 */
        goodsEvaluateStatus: 1,
        /* 商品评论 */
        showGoodsEvaluateStatus: 1,
        /* 显示商品评论 */
        //newCommentEmailAlertStatus:1,/* 新评论邮件提醒 */
        //stepFreightStatus:0,/* 阶梯运费 */
        baiduTranslateAppid: '',
        baiduTranslateAppscript: '',
        arrivalTimeReminderList: [],
        /* 到货时间提醒list */
        leaveWordReminderList: [],
        /* 留言提醒list */
        remindSmsLimit: "",
        ipSmsLimit: '',
        phoneSmsLimit: '',
        orderAmountShowDays: ''
      }
    }, "rules", {
      phoneSmsLimit: [{
        required: true,
        message: this.$t('public.enterPlease'),
        trigger: 'blur'
      }],
      ipSmsLimit: [{
        required: true,
        message: this.$t('public.enterPlease'),
        trigger: 'blur'
      }],
      remindSmsLimit: [{
        required: true,
        message: this.$t('public.enterPlease'),
        trigger: 'blur'
      }],
      maxLoginNumber: [{
        required: true,
        message: this.$t('public.enterPlease'),
        trigger: 'blur'
      }],
      orderAmountShowDays: [{
        required: true,
        message: this.$t('public.enterPlease'),
        trigger: 'blur'
      }]
    });
  },
  mounted: function mounted() {
    this.getLanguageList();
  },
  methods: {
    //初始化数据
    initData: function initData() {
      var _this = this;
      var self = this;
      // self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      var arrivalTimeReminderList = [];
      var leaveWordReminderList = [];
      //遍历到货时间提醒文字，留言提醒文字
      self.languageList.forEach(function (item) {
        var arrivalTimeReminder = {};
        var leaveWordReminder = {};
        leaveWordReminder.langId = item.id;
        arrivalTimeReminder.langId = item.id;
        arrivalTimeReminder.showFY = false;
        leaveWordReminder.showFY = false;
        leaveWordReminder.languageName = _this.$t('basicSettings.leaveWordReminder') + "(" + item.name + ')';
        arrivalTimeReminder.languageName = _this.$t('basicSettings.arrivalTimeReminder') + "(" + item.name + ')';
        self.systemSettingData.arrivalTimeReminderList.forEach(function (item2) {
          if (item.id == item2.langId) {
            arrivalTimeReminder.content = item2.content;
          }
        });
        self.systemSettingData.leaveWordReminderList.forEach(function (item3) {
          if (item.id == item3.langId) {
            leaveWordReminder.content = item3.content;
          }
        });
        arrivalTimeReminderList.push(arrivalTimeReminder);
        leaveWordReminderList.push(leaveWordReminder);
      });
      self.dataForm = {
        stockThreshold: self.systemSettingData.stockThreshold,
        arrivalNoticeThreshold: self.systemSettingData.arrivalNoticeThreshold,
        clientLanguageDisplayIds: self.systemSettingData.clientLanguageDisplayIds.split(","),
        lowStockLimit: self.systemSettingData.lowStockLimit,
        maxLoginNumber: self.systemSettingData.maxLoginNumber,
        sendBundleStatus: self.systemSettingData.sendBundleStatus,
        goodsEvaluateStatus: self.systemSettingData.goodsEvaluateStatus,
        showGoodsEvaluateStatus: self.systemSettingData.showGoodsEvaluateStatus,
        baiduTranslateAppid: self.systemSettingData.baiduTranslateAppid,
        baiduTranslateAppscript: self.systemSettingData.baiduTranslateAppscript,
        arrivalTimeReminderList: arrivalTimeReminderList,
        leaveWordReminderList: leaveWordReminderList,
        id: self.systemSettingData.id,
        lastUpdateTime: self.systemSettingData.lastUpdateTime,
        phoneSmsLimit: self.systemSettingData.phoneSmsLimit,
        ipSmsLimit: self.systemSettingData.ipSmsLimit,
        remindSmsLimit: self.systemSettingData.remindSmsLimit,
        orderAmountShowDays: self.systemSettingData.orderAmountShowDays
      };
    },
    showFYBtn: function showFYBtn(item) {
      var self = this;
      // let brandNameListClone = self.fromData.multilingualList;
      var _iterator = _createForOfIteratorHelper(self.dataForm.arrivalTimeReminderList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var one = _step.value;
          one.showFY = false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(self.dataForm.leaveWordReminderList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _one = _step2.value;
          _one.showFY = false;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      item.showFY = true;
    },
    getLanguageList: function getLanguageList() {
      var _this2 = this;
      var self = this;
      _getLanguageList().then(function (res) {
        if (res.data.code == 200) {
          //获取语言list
          self.languageList = res.data.data;
          _this2.initData();
          //变成组件需要的属性名
          self.clientLanguageDisplayList = res.data.data.map(function (item) {
            //获取默认语言名称
            if (item.id == self.systemSetting.defaultLanguageId) {
              //默认语言名称
              self.dataForm.shopDefaultLanguage = item.name;
            }
            var obj = {
              label: item.name,
              value: item.id + "",
              disabled: self.systemSetting.defaultLanguageId == item.id
            };
            return obj;
          });
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
    },
    /* 保存 */save: function save() {
      var _this3 = this;
      var self = this;
      var param = {
        id: self.dataForm.id,
        lastUpdateTime: self.dataForm.lastUpdateTime,
        stockThreshold: self.dataForm.stockThreshold,
        arrivalNoticeThreshold: self.dataForm.arrivalNoticeThreshold,
        clientLanguageDisplayIds: self.dataForm.clientLanguageDisplayIds.toString(),
        lowStockLimit: self.dataForm.lowStockLimit,
        maxLoginNumber: self.dataForm.maxLoginNumber,
        sendBundleStatus: self.dataForm.sendBundleStatus,
        goodsEvaluateStatus: self.dataForm.goodsEvaluateStatus,
        showGoodsEvaluateStatus: self.dataForm.showGoodsEvaluateStatus,
        baiduTranslateAppid: self.dataForm.baiduTranslateAppid,
        baiduTranslateAppscript: self.dataForm.baiduTranslateAppscript,
        arrivalTimeReminderList: self.dataForm.arrivalTimeReminderList,
        leaveWordReminderList: self.dataForm.leaveWordReminderList,
        phoneSmsLimit: self.dataForm.phoneSmsLimit,
        ipSmsLimit: self.dataForm.ipSmsLimit,
        remindSmsLimit: self.dataForm.remindSmsLimit,
        orderAmountShowDays: self.dataForm.orderAmountShowDays
      };
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          self.saveLoading = true;
          updateOtherSetting(param).then(function (result) {
            if (result.data.code == 200) {
              //更新成功后更新 最后更新时间
              self.$emit('update');
              _this3.$message.success(_this3.$t('public.saveSuccessfully'));
            }
            self.saveLoading = false;
          }).finally(function () {
            self.saveLoading = false;
          });
        } else {
          console.log('error submit!!');
          self.saveLoading = false;
          return false;
        }
      });
    }
  }
};